import React, { useRef, useState, useEffect } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Select,
  DatePicker,
  Space,
  Form,
  message,
  Input,
  Modal,
  Checkbox,
  Dropdown,
  TimePicker,
} from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { CSVLink } from "react-csv";
// Redux
import { connect } from "react-redux";
import {
  getUserRoleId,
  getAllDepartmentList,
  getSelectedDepartmentId,
  getShiftTimeMaster,
  getClientid,
  getUserList,
  getMenuList,
  getUserInfo,
} from "redux/selectors";

import { CALL_API } from "common/API";
import {
  MONTH_LIST,
  REPORT_DURATION_TYPES,
  STATUS_CODE,
} from "common/Constants";

import {
  addDaysinDate,
  dateInDetail,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
  addMonthinDate,
  differenceBetweenTwoTime,
} from "utils/Date";
import COLORS from "common/Colors";
import { concat, find, get, includes, reduce, uniqBy } from "lodash";
import Form1 from "react-bootstrap/Form";
import ViewMore from "organisms/ViewMore";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import dayjs from "dayjs";
import { SortAscendingOutlined } from "@ant-design/icons";

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  .ant-table-cell {
    padding: 14px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
  .normal-column {
    min-width: 200px;
    white-space: normal;
  }
  .stylediv {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000014;
    border-radius: 5px;
    opacity: 1;
    margin: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .styleddiv {
    background: #26a4ff;
    color: white;
    box-shadow: 0px 3px 6px #00000014;
    border-radius: 5px;
    opacity: 1;
    margin: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .stylebutton-yes {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000014;
    border-radius: 5px;
    opacity: 1;
    border: none;
    margin: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    :hover {
      background: #198754;
      color: white;
    }
  }
  .stylebutton-no {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000014;
    border-radius: 5px;
    opacity: 1;
    border: none;
    margin: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    :hover {
      background: #ff4d4f;
      color: white;
    }
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }
  .ant-form-item {
    display: inline-block;
  }
  .outer-form {
    margin-right: 0px;
  }
  .ant-select-selector {
    max-width: 180px;
    min-width: 180px;
    margin-bottom: 10px;
    width: 180px;
  }
`;
const StyledButton2 = styled(Button)`
  width: 120px;
  border: 1px solid ${COLORS.PRIMARY};
  color: ${COLORS.PRIMARY};
  width: initial;
  background: transparent;
  border-radius: 5px;
`;
const StyledButtonoutlined = styled(ButtonOutlined)`
  @media (max-width: 768px) {
    margin-left: -40px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px;
  }
`;
const Overtimewrap = styled.div`
  .change-view {
    color: #2d53da;
    border-radius: 10px;
  }
  .change-view:disabled {
    color: #e3e8fc !important;
  }
  .change-view: hover {
    background: #c5cff5;
  }
`;

function OvertimeReport({
  userRoleId,
  allDepartmentList,
  selectedDepartmentId,
  userList,
  ClientId,
  menuList,
  userInfo,
}) {
  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [overtimeList, setOvertimeList] = useState([]);
  const [overtimeList1, setOvertimeList1] = useState([]);
  const [CSVOvertimeList, setCSVOvertimeList] = useState([]);
  const [form] = Form.useForm();
  const [updateform] = Form.useForm();
  const csvLinkEl = useRef();
  const [ActionType, setActionType] = useState("1");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [recordlist, setrecordlist] = useState([]);
  const [clickactionId, setclickactionId] = useState(0);
  const [filterList, setFilterList] = useState([]);
  const { TextArea } = Input;
  const [monthList, setMonthList] = useState([]);
  const containerRef = useRef(null);
  const pageTitleRef = useRef(null);
  const [activeSortColumn, setActiveSortColumn] = useState([]);
  const [uiTableData, setUITableData] = useState([]);
  const [pageTitleHeight, setPageTitleHeight] = useState(0);
  const [showSelection, setShowSelection] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isbulkApproveModalOpen, setIsbulkApproveModalOpen] = useState(false);
  const [isbulkDeclineModalOpen, setIsbulkDeclineModalOpen] = useState(false);

  const handleTableChange = (pagination, filters, sorter, extra) => {
    setUITableData(extra.currentDataSource);
  };

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const curr_month = moment().month() + 1;

  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(month_list);
  };

  // Derived staff list only from the current data (ActionType determines which source)
  const STAFF_LIST = React.useMemo(() => {
    const list = userList.map((val) => ({
      userid: val.userid,
      // Use either fullname or fullName depending on API response
      name: val.fullname || val.fullName || "",
    }));
    // Remove duplicates by userid
    const uniq = uniqBy(list, "userid");
    return uniq.sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
    );
  }, [userList]);

  const selectedStaff = Form.useWatch("staff_name", form);
  const selectedDept = Form.useWatch("department", form);

  const getDepartmentsFromData = () => {
    const currentData = ActionType === "1" ? overtimeList : overtimeList1;
    const departmentField =
      ActionType === "1" ? "departmentid" : "departmentId";
    const departmentNameField =
      ActionType === "1" ? "departmentname" : "departmentName";
    const uniqueDepartments = [
      ...new Set(currentData?.map((item) => item[departmentField])),
    ];
    return uniqueDepartments
      ?.map((deptId) => {
        const deptItem = currentData?.find(
          (item) => item[departmentField] === deptId
        );
        return {
          department_id: deptId,
          department_name: deptItem ? deptItem[departmentNameField] : deptId,
        };
      })
      ?.filter(
        (dept) =>
          dept.department_id !== null &&
          dept.department_id !== undefined &&
          dept.department_name
      );
  };

  const availableDepartments = getDepartmentsFromData();
  const overtimefilterdata = overtimeList?.filter((val) => {
    const matchesStaff = !selectedStaff || val.userid === selectedStaff;
    const matchesDept =
      selectedDept === "" || val.departmentid === parseInt(selectedDept);
    return matchesStaff && matchesDept;
  });

  const overtimefilterdata1 = overtimeList1?.filter((val) => {
    const matchesStaff = !selectedStaff || val.userid === selectedStaff;
    const matchesDept =
      selectedDept === "" || val.departmentId === parseInt(selectedDept);
    return matchesStaff && matchesDept;
  });

  const errorValidation = (values) => {
    let errors = {};
    if (!values.hours) {
      errors.hours = "This field is required";
    }
    if (!values.notes) {
      errors.notes = "This field is required";
    }
    return errors;
  };

  const [values, setValues] = useState({
    hours: "00:00",
    notes: "",
  });
  const [dataIsCorrect, setDataiscorrect] = useState(false);
  const [errors, setErrors] = useState({});
  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };
  const handleFormsubmit = (event) => {
    event.preventDefault();

    setErrors(errorValidation(values));
    setDataiscorrect(true);
  };

  const resetValues = () => {
    setValues({
      notes: "",
    });
  };

  useEffect(() => {
    if (Object.keys(errors).length === 0 && dataIsCorrect) {
      update();
      setIsModalOpen(false);
      setTimeout(() => {
        getOvertimeReport();
      }, 2000);
    }
  }, [errors]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    resetValues();
  };

  const getToltalWorkHours = (record) => {
    const checkinDateTime = dayjs(
      `${dayjs(record.checkindate).format("YYYY-MM-DD")} ${
        record.shiftstarttime
      }:00`,
      "YYYY-MM-DD HH:mm:ss"
    );

    const checkoutDateTime = dayjs(
      `${dayjs(record.checkoutdate).format("YYYY-MM-DD")} ${
        record.checkouttime
      }`,
      "YYYY-MM-DD HH:mm:ss"
    );

    const diffInMinutes = checkoutDateTime.diff(checkinDateTime, "minute");
    const result = diffInMinutes;
    if (result <= 0) {
      return "00:00";
    }
    return generateHourMinutesFromMinutes(result);
  };

  const getOvertimeDuration = (record) => {
    // Use shift end time on check-in date as the shift end datetime

    const checkinDateTime = dayjs(
      `${dayjs(record.checkindate).format("YYYY-MM-DD")} ${
        record.shiftstarttime
      }:00`,
      "YYYY-MM-DD HH:mm:ss"
    );

    const checkoutDateTime = dayjs(
      `${dayjs(record.checkoutdate).format("YYYY-MM-DD")} ${
        record.checkouttime
      }`,
      "YYYY-MM-DD HH:mm:ss"
    );

    // Only compute overtime if checkout is after shift end
    // if (checkoutDateTime.isAfter(shiftEndDateTime)) {
    const diffInMinutes = checkoutDateTime.diff(checkinDateTime, "minute");
    const result = diffInMinutes - 8 * 60;
    if (result <= 0) {
      return "00:00";
    }
    return generateHourMinutesFromMinutes(result);
    // }

    // return "00:00";
  };

  // const generateHourMinutesFromMinutes = (minutes) => {
  //   const hours = Math.floor(minutes / 60);
  //   const mins = minutes % 60;
  //   return `${hours.toString().padStart(2, "0")}:${mins
  //     .toString()
  //     .padStart(2, "0")}`;
  // };
  const generateHourMinutesFromMinutes = (minutes) => {
    const sign = minutes < 0 ? "-" : "";
    const absMinutes = Math.abs(minutes);

    const hours = Math.floor(absMinutes / 60);
    const mins = absMinutes % 60;

    return `${sign}${hours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}`;
  };

  // Parse a string in format "HH:mm" to total minutes
  // const parseHourMinutesStringToMinutes = (timeStr) => {
  //   if (!timeStr) return 0;
  //   if (typeof timeStr === "number") return timeStr; // already in minutes
  //   const parts = timeStr.split(":").map((p) => parseInt(p, 10));
  //   if (!parts || parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1]))
  //     return 0;
  //   return parts[0] * 60 + parts[1];
  // };

  const parseHourMinutesStringToMinutes = (timeStr) => {
    if (!timeStr) return 0;

    // If already a number → treat as minutes
    if (typeof timeStr === "number") return timeStr;

    // Split by ":" → supports HH:mm or HH:mm:ss
    const parts = timeStr.split(":").map((p) => parseInt(p, 10));

    if (parts.some(isNaN)) return 0;

    const [h = 0, m = 0, s = 0] = parts; // seconds optional

    // Convert HH:mm:ss → total minutes
    return h * 60 + m + Math.floor(s / 60);
  };

  const overtimeactionclick = (record) => {
    const overTimeStr = getOvertimeDuration(record);
    const overtimeMinutes = parseHourMinutesStringToMinutes(overTimeStr);

    const diff = differenceBetweenTwoTime(
      record.shiftstarttime,
      record.checkintime
    );
    const lateMinutes = record?.punchinstatus === "late" ? diff : 0;
    const breakMinutes = record?.breakduration ? record?.breakduration : 0;
    const finalMinutes =
      overtimeMinutes -
      lateMinutes -
      parseHourMinutesStringToMinutes(breakMinutes);
    const overtimeDuration = generateHourMinutesFromMinutes(finalMinutes);
    showModal();
    setrecordlist(record);
    setclickactionId(1);
    setValues({
      hours: overtimeDuration === "00:00" ? "00:00" : overtimeDuration,
    });
  };

  const overtimeactionclick1 = (record) => {
    showModal();
    setrecordlist(record);
    setclickactionId(2);
    setValues({ hours: "00:00" });
  };

  const update = async (record) => {
    setLoading(true);
    const filteruser = userList?.filter(
      (item) => item?.userid === recordlist?.userid
    );

    const overTimeStr = getOvertimeDuration(recordlist);
    const overtimeMinutes = parseHourMinutesStringToMinutes(overTimeStr);

    const diff = differenceBetweenTwoTime(
      recordlist.shiftstarttime,
      recordlist.checkintime
    );
    const lateMinutes = recordlist?.punchinstatus === "late" ? diff : 0;
    const breakMinutes = recordlist?.breakduration
      ? recordlist?.breakduration
      : 0;
    const finalMinutes =
      overtimeMinutes -
      lateMinutes -
      parseHourMinutesStringToMinutes(breakMinutes);
    const overtimeDuration = generateHourMinutesFromMinutes(finalMinutes);
    const payload = {
      user_id: recordlist?.userid,
      employeeid: filteruser[0]?.employeeid,
      name: recordlist?.fullname,
      start_time: recordlist?.checkintime,
      end_time: recordlist?.checkouttime,
      shiftendtime: recordlist?.shiftendtime,
      departmentname: recordlist?.departmentname,
      duration: getOvertimeDuration(recordlist),
      status_id: clickactionId,
      overtime_update: `${values?.hours}:00`,
      department_id: recordlist?.departmentid,
      checkin_id: recordlist?.userpunchactionid,
      date: recordlist?.checkindate,
      commands: values?.notes,
      reportingmanager: recordlist?.reportingmanager || "",
      checkouttype: recordlist?.checkouttype || "",
      punchoutstatus: recordlist?.punchoutstatus || "",
      totalworkduration: getToltalWorkHours(recordlist),
      latecheckinduration:
        recordlist?.punchinstatus === "late"
          ? generateHourMinutesFromMinutes(diff)
          : "00:00",
      breakduration: recordlist?.breakduration
        ? recordlist?.breakduration
        : "-",
      initialovertime: getOvertimeDuration(recordlist),
      finalovertime: overtimeDuration,
      break_status: recordlist?.break_status === "auto" ? "auto" : "manual",
      bulkupdatelist:
        selectedRows?.length > 0
          ? selectedRows?.map((item) => {
              const user = userList?.find(
                (user) => user?.userid === item?.userid
              );

              const overTimeStr = getOvertimeDuration(item);
              const overtimeMinutes =
                parseHourMinutesStringToMinutes(overTimeStr);

              const diff = differenceBetweenTwoTime(
                item.shiftstarttime,
                item.checkintime
              );

              const lateMinutes = item?.punchinstatus === "late" ? diff : 0;
              const breakMinutes = item?.breakduration
                ? item?.breakduration
                : 0;

              const finalMinutes =
                overtimeMinutes -
                lateMinutes -
                parseHourMinutesStringToMinutes(breakMinutes);

              const overtimeDuration =
                generateHourMinutesFromMinutes(finalMinutes);

              return {
                user_id: item?.userid,
                employeeid: user?.employeeid,
                name: item?.fullname,
                start_time: item?.checkintime,
                end_time: item?.checkouttime,
                shiftendtime: item?.shiftendtime,
                departmentname: item?.departmentname,
                duration: getOvertimeDuration(item),
                status_id: isbulkApproveModalOpen ? 1 : 2,

                overtime_update: isbulkApproveModalOpen
                  ? `${
                      item?.changedovertime
                        ? item?.changedovertime
                        : overtimeDuration
                    }:00`
                  : "00:00:00",

                department_id: item?.departmentid,
                checkin_id: item?.userpunchactionid,
                date: item?.checkindate,
                commands: updateform?.getFieldValue("notes") || "",
                reportingmanager: item?.reportingmanager || "",
                checkouttype: item?.checkouttype || "",
                punchoutstatus: item?.punchoutstatus || "",
                totalworkduration: getToltalWorkHours(item),
                latecheckinduration:
                  item?.punchinstatus === "late"
                    ? generateHourMinutesFromMinutes(diff)
                    : "00:00",
                breakduration: item?.breakduration
                  ? item?.breakduration
                  : "00:00",
                initialovertime: getOvertimeDuration(item),
                finalovertime: overtimeDuration,
                break_status: item?.break_status === "auto" ? "auto" : "manual",
              };
            })
          : [],
    };
    console.log("payload-->", payload);
    const { code } = await CALL_API(
      `overtime-action/${ClientId}`,
      "patch",
      payload
    );
    if (isbulkApproveModalOpen || isbulkDeclineModalOpen) {
      if (isbulkApproveModalOpen) {
        message?.success("Bulk Approved successfully");
      } else {
        message?.success("Bulk Declined successfully");
      }
      updateform.resetFields();
      setIsbulkApproveModalOpen(false);
      setIsbulkDeclineModalOpen(false);
      setShowSelection(false);
      setSelectedRowKeys([]);
      setSelectedRows([]);
      getOvertimeReport();
    }

    resetValues();
    setLoading(false);
  };

  const columns = [
    {
      title: "Employee ID",
      dataIndex: ActionType === "1" ? "userid" : "employeeId",
      key: ActionType === "1" ? "userid" : "employeeId",
      width: 130,
      render: (userId) => {
        const filteruser = userList?.filter((item) => item?.userid === userId);
        return ActionType === "1" ? filteruser[0]?.employeeid : userId;
      },
    },
    {
      title: "Employee Name",
      dataIndex: ActionType === "1" ? "fullname" : "fullName",
      key: ActionType === "1" ? "fullname" : "fullName",
      width: 200,
    },
    {
      title: "Department",
      dataIndex: ActionType === "1" ? "departmentname" : "departmentName",
      key: ActionType === "1" ? "departmentname" : "departmentName",
      width: 160,
    },
    {
      title: "Checkout Type",
      dataIndex: ActionType === "1" ? "checkouttype" : "checkouttype",
      key: ActionType === "1" ? "checkouttype" : "checkouttype",
      width: 140,
    },
    {
      title: "Checkin Date",
      dataIndex: ActionType === "2" ? "overtimeDate" : "checkindate",
      key: ActionType === "2" ? "overtimeDate" : "checkindate",
      width: 140,
      render: (checkinDate) => {
        const checkinDateFormat = moment(checkinDate).format("DD MMM YYYY");
        return `${checkinDateFormat}`;
      },
    },
    {
      title: "Checkin Day",
      dataIndex: ActionType === "2" ? "overtimeday" : "checkinday",
      key: ActionType === "2" ? "overtimeday" : "checkinday",
      width: 130,
      render: (checkinDate, record) => {
        if (ActionType === "2") {
          const getdayAlone = moment(record?.overtimeDate).format("dddd");
          return `${getdayAlone}`;
        } else {
          const getdayAlone = moment(record?.checkindate).format("dddd");
          return `${getdayAlone}`;
        }
      },
    },
    {
      title: "Checkin Time",
      dataIndex: ActionType === "2" ? "startTime" : "checkintime",
      key: ActionType === "2" ? "startTime" : "checkintime",
      width: 130,
      render: (time) => {
        const formattedTime = moment(time, "HH:mm:ss").format("HH:mm");
        return `${formattedTime}`;
      },
    },
    {
      title: "Checkout Date",
      dataIndex: ActionType === "2" ? "overtimeDate" : "checkoutdate",
      key: ActionType === "2" ? "overtimeDate" : "checkoutdate",
      width: 140,
      render: (checkoutDate) => {
        const dateFormat = moment(checkoutDate).format("DD MMM YYYY");
        return `${dateFormat}`;
      },
    },
    {
      title: "Checkout Day",
      dataIndex: ActionType === "2" ? "overtimeday" : "checkoutday",
      key: ActionType === "2" ? "overtimeday" : "checkoutday",
      width: 140,
      render: (checkoutDate, record) => {
        if (ActionType === "2") {
          const getdayAlone = moment(record?.overtimeDate).format("dddd");
          return `${getdayAlone}`;
        } else {
          const getdayAlone = moment(record?.checkoutdate).format("dddd");
          return `${getdayAlone}`;
        }
      },
    },
    {
      title: "Checkout Time",
      dataIndex: ActionType === "1" ? "checkouttime" : "endTime",
      key: ActionType === "1" ? "checkouttime" : "endTime",
      width: 140,
      render: (time) => {
        const formattedTime = moment(time, "HH:mm:ss").format("HH:mm");
        return `${formattedTime}`;
      },
    },
    {
      title: "Total Work Duration",
      dataIndex: "totalworkduration",
      key: "totalworkduration",
      width: 220,
      render: (_, record) => {
        if (ActionType === "1") {
          return getToltalWorkHours(record);
        }
        return record?.totalworkduration || "00:00";
      },
    },
    {
      title: "Initial Overtime",
      dataIndex: "initialovertime",
      key: "initialovertime",
      width: 220,
      render: (_, record) => {
        if (ActionType === "1") {
          return getOvertimeDuration(record);
        }
        return record?.initialovertime || "00:00";
      },
    },
    {
      title: "Late Check-in Duration",
      dataIndex: "latecheckinduration",
      key: "latecheckinduration",
      width: 220,
      render: (_, record) => {
        if (ActionType === "1") {
          const diff = differenceBetweenTwoTime(
            record.shiftstarttime,
            record.checkintime
          );
          return record?.punchinstatus === "late"
            ? generateHourMinutesFromMinutes(diff)
            : "00:00";
        }

        return record?.latecheckinduration;
      },
    },
    {
      title: "Break Time",
      dataIndex: "breakduration",
      key: "breakduration",
      width: 220,
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Break Type",
      dataIndex: "break_status",
      key: "break_status",
      width: 100,
      render: (breakId) => {
        return breakId ? (breakId === "auto" ? "Auto" : "Manual") : "-";
      },
    },
    {
      title: "Final Overtime",
      dataIndex: "finalovertime",
      key: "finalovertime",
      width: 220,
      render: (_, record) => {
        if (ActionType === "1") {
          // compute overtime in minutes and subtract late minutes (if any)
          const overTimeStr = getOvertimeDuration(record);
          const overtimeMinutes = parseHourMinutesStringToMinutes(overTimeStr);

          const diff = differenceBetweenTwoTime(
            record.shiftstarttime,
            record.checkintime
          );
          const lateMinutes = record?.punchinstatus === "late" ? diff : 0;
          const breakMinutes = record?.breakduration
            ? record?.breakduration
            : 0;
          const finalMinutes =
            overtimeMinutes -
            lateMinutes -
            parseHourMinutesStringToMinutes(breakMinutes);
          return generateHourMinutesFromMinutes(finalMinutes);
        }
        return record?.overtimeDuration || "00:00";
      },
    },
  ];
  if (
    ActionType === "1" &&
    Menulist?.find(
      (item) =>
        item?.key === "reports" &&
        item?.subMenu.find(
          (subItem) =>
            subItem?.key === "overtime-report" && subItem?.permission.edit
        )
    )
  ) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      key: "overtimeDuration",
      width: 140,
      render: (_, record) => {
        return (
          <Row
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Row>
              <Col>
                <button
                  className="stylebutton-yes"
                  onClick={() => overtimeactionclick(record)}
                >
                  Yes
                </button>{" "}
              </Col>
              <Col>
                <button
                  className="stylebutton-no"
                  onClick={() => overtimeactionclick1(record)}
                >
                  No
                </button>
              </Col>
            </Row>
          </Row>
        );
      },
    });
  }
  if (ActionType === "2") {
    columns.push(
      {
        title: "Action",
        dataIndex: "action",
        key: "overtimeDuration",
        width: 100,
        render: (_, record) => {
          return (
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {ActionType === "2" && (
                <Row>
                  {record?.statusId === 1 ? (
                    <Col>
                      <div
                        style={{ background: "#198754" }}
                        className="styleddiv"
                      >
                        Yes
                      </div>
                    </Col>
                  ) : (
                    <Col>
                      <div
                        style={{ background: "#FF4D4F" }}
                        className="styleddiv"
                      >
                        No
                      </div>
                    </Col>
                  )}
                </Row>
              )}
            </Row>
          );
        },
      },
      {
        title: "Overtime Amended",
        dataIndex: "overtimeUpdate",
        key: "overtimeUpdate",
        width: 200,
      },
      {
        title: "Comments",
        dataIndex: "commands",
        key: "commands",
        width: 200,
        className: "normal-column",
        render: (reason) => {
          return (
            <>
              <ViewMore value={reason} />
            </>
          );
        },
      }
    );
  }

  const columnsWithSorting = columns.map((col) => ({
    ...col,
    sorter: activeSortColumn.includes(col.dataIndex)
      ? (a, b) => {
          // ✅ Day-based columns (derived from date)
          if (
            col.dataIndex === "overtimeday" ||
            col.dataIndex === "overtimeday_checkout"
          ) {
            return moment(a.overtimeDate).day() - moment(b.overtimeDate).day();
          }
          if (col.dataIndex === "checkinday") {
            return moment(a.checkindate).day() - moment(b.checkindate).day();
          }
          if (col.dataIndex === "checkoutday") {
            return moment(a.checkoutdate).day() - moment(b.checkoutdate).day();
          }

          // ✅ Total Work Duration
          if (col.dataIndex === "totalworkduration") {
            const aDuration =
              ActionType === "1"
                ? getToltalWorkHours(a)
                : a?.totalworkduration || "00:00";
            const bDuration =
              ActionType === "1"
                ? getToltalWorkHours(b)
                : b?.totalworkduration || "00:00";

            return (
              parseHourMinutesStringToMinutes(aDuration) -
              parseHourMinutesStringToMinutes(bDuration)
            );
          }

          // ✅ Initial Overtime
          if (col.dataIndex === "initialovertime") {
            const aInitial =
              ActionType === "1"
                ? getOvertimeDuration(a)
                : a?.initialovertime || "00:00";
            const bInitial =
              ActionType === "1"
                ? getOvertimeDuration(b)
                : b?.initialovertime || "00:00";

            return (
              parseHourMinutesStringToMinutes(aInitial) -
              parseHourMinutesStringToMinutes(bInitial)
            );
          }

          // ✅ Late Check-in Duration
          if (col.dataIndex === "latecheckinduration") {
            let aLate = "00:00";
            let bLate = "00:00";

            if (ActionType === "1") {
              const aDiff = differenceBetweenTwoTime(
                a.shiftstarttime,
                a.checkintime
              );
              const bDiff = differenceBetweenTwoTime(
                b.shiftstarttime,
                b.checkintime
              );
              aLate =
                a?.punchinstatus === "late"
                  ? generateHourMinutesFromMinutes(aDiff)
                  : "00:00";
              bLate =
                b?.punchinstatus === "late"
                  ? generateHourMinutesFromMinutes(bDiff)
                  : "00:00";
            } else {
              aLate = a?.latecheckinduration || "00:00";
              bLate = b?.latecheckinduration || "00:00";
            }

            return (
              parseHourMinutesStringToMinutes(aLate) -
              parseHourMinutesStringToMinutes(bLate)
            );
          }

          // ✅ Final Overtime

          if (col.dataIndex === "finalovertime") {
            let aFinal = "00:00";
            let bFinal = "00:00";

            if (ActionType === "1") {
              const aOverTimeStr = getOvertimeDuration(a);
              const aOvertimeMinutes =
                parseHourMinutesStringToMinutes(aOverTimeStr);
              const aDiff = differenceBetweenTwoTime(
                a.shiftstarttime,
                a.checkintime
              );
              const aLateMinutes = a?.punchinstatus === "late" ? aDiff : 0;
              const aBreakMinutes = a?.breakduration ? a?.breakduration : 0;
              const aFinalMinutes =
                aOvertimeMinutes -
                aLateMinutes -
                parseHourMinutesStringToMinutes(aBreakMinutes);
              aFinal = generateHourMinutesFromMinutes(aFinalMinutes);

              const bOverTimeStr = getOvertimeDuration(b);
              const bOvertimeMinutes =
                parseHourMinutesStringToMinutes(bOverTimeStr);
              const bDiff = differenceBetweenTwoTime(
                b.shiftstarttime,
                b.checkintime
              );
              const bLateMinutes = b?.punchinstatus === "late" ? bDiff : 0;
              const bBreakMinutes = b?.breakduration ? b?.breakduration : 0;
              const bFinalMinutes =
                bOvertimeMinutes -
                bLateMinutes -
                parseHourMinutesStringToMinutes(bBreakMinutes);
              bFinal = generateHourMinutesFromMinutes(bFinalMinutes);
            } else {
              aFinal = a?.overtimeDuration || "00:00";
              bFinal = b?.overtimeDuration || "00:00";
            }

            return (
              parseHourMinutesStringToMinutes(aFinal) -
              parseHourMinutesStringToMinutes(bFinal)
            );
          }

          // ✅ Break Duration
          if (col.dataIndex === "breakduration") {
            const aDuration = a.breakduration || "00:00";
            const bDuration = b.breakduration || "00:00";
            return (
              parseHourMinutesStringToMinutes(aDuration) -
              parseHourMinutesStringToMinutes(bDuration)
            );
          }

          // ✅ Checkout date for ActionType 2 (using overtimeDate)
          if (col.dataIndex === "overtimeDate_checkout") {
            return (
              moment(a.overtimeDate).valueOf() -
              moment(b.overtimeDate).valueOf()
            );
          }

          const aVal = a[col.dataIndex];
          const bVal = b[col.dataIndex];

          // ✅ Date sort (ISO)
          if (
            moment(aVal, moment.ISO_8601, true).isValid() &&
            moment(bVal, moment.ISO_8601, true).isValid()
          ) {
            return moment(aVal).valueOf() - moment(bVal).valueOf();
          }

          // ✅ String sort
          if (typeof aVal === "string" && typeof bVal === "string") {
            return aVal.localeCompare(bVal);
          }

          // ✅ Number sort (fallback)
          return (aVal ?? 0) - (bVal ?? 0);
        }
      : false,
  }));

  const SORT_OPTIONS = columns.map((col) => ({
    label: col.title,
    value: col.dataIndex,
  }));

  const finalColumns =
    activeSortColumn.length > 0
      ? columnsWithSorting.filter((col) =>
          activeSortColumn.includes(col.dataIndex)
        )
      : columnsWithSorting;

  const CSVHeaders =
    activeSortColumn.length > 0
      ? columns
          .filter((col) => activeSortColumn.includes(col.dataIndex))
          .map((col) => ({
            label: col.title,
            key: col.title,
          }))
      : [
          { label: "Employee ID", key: "Employee ID" },
          { label: "Employee Name", key: "Employee Name" },
          { label: "Department", key: "Department" },
          { label: "Checkin Date", key: "Checkin Date" },
          { label: "Checkin Time", key: "Checkin Time" },
          { label: "Checkout Time", key: "Checkout Time" },
          { label: "Duration (Hours)", key: "Duration (Hours)" },
          { label: "Late time (Hours)", key: "Late time (Hours)" },
          ActionType === "2" && [
            { label: "Overtime Amended", key: "Overtime Amended" },
            { label: "Comments", key: "Comments" },
          ],
        ];

  const sortMenu = (
    <div
      style={{
        padding: 12,
        width: 200,
        maxHeight: 300,
        overflowY: "scroll",
        background: "#fff",
        boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
        fontWeight: 400,
      }}
    >
      <Checkbox.Group
        value={activeSortColumn}
        options={SORT_OPTIONS}
        onChange={(values) => setActiveSortColumn(values)}
        style={{ display: "flex", flexDirection: "column", gap: 8 }}
      />
    </div>
  );

  useEffect(() => {
    list();
    getOvertimeReport();
  }, [
    selectedDepartmentId,
    ActionType,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("start_date"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("department"),
    form.getFieldValue("break_status"),
  ]);

  useEffect(() => {
    const selectedDept = form.getFieldValue("department");
    if (selectedDept && availableDepartments.length > 0) {
      const isDeptAvailable = availableDepartments.some(
        (dept) => dept.department_id === parseInt(selectedDept)
      );
      if (!isDeptAvailable) {
        form.setFieldsValue({ department: "" });
      }
    }
  }, [availableDepartments, form]);

  // Function to generate report
  const getOvertimeReport = async () => {
    return new Promise(async (resolve, reject) => {
      setOvertimeList([]);
      const { start_date, end_date, duration_type, month, department } =
        form.getFieldsValue();
      setDisplayTableLoader(true);
      const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
        dateInDetail(getKenyanDateTime()).year,
        get(find(MONTH_LIST, { value: month }), "index", 0)
      );
      if (ActionType === "1") {
        const { code, overtimeList = [] } = await CALL_API(
          `overtime-report/${ClientId}`,
          "post",
          {
            department: [""],
            // userRoleId === 1 || userRoleId === 6
            //   ? [department]
            //   : selectedDepartmentId,
            start_date: getMySqlDate(
              duration_type === 2 ? startDateOfMonth : start_date
            ),
            end_date: getMySqlDate(
              duration_type === 2 ? lastDateOfMonth : end_date
            ),
            reportingmanager: userInfo?.userid,
            break_status:
              form.getFieldValue("break_status")?.toLocaleLowerCase() || "",
          }
        );

        setDisplayTableLoader(false);
        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setOvertimeList(
            [...overtimeList].sort(
              (a, b) =>
                new Date(b.checkindatetime) - new Date(a.checkindatetime)
            )
          );
        }
      } else {
        const { code, overTimeActionList = [] } = await CALL_API(
          `overtime-action/${ClientId}`,
          "post",
          {
            departmentId: [""],
            // userRoleId === 1 || userRoleId === 6
            //   ? [department]
            //   : selectedDepartmentId,

            start_date: getMySqlDate(
              duration_type === 2 ? startDateOfMonth : start_date
            ),
            end_date: getMySqlDate(
              duration_type === 2 ? lastDateOfMonth : end_date
            ),
            reportingmanager: userInfo?.userid,
            break_status:
              form.getFieldValue("break_status")?.toLocaleLowerCase() || "",
          }
        );
        setDisplayTableLoader(false);
        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setOvertimeList1(
            [...overTimeActionList].sort(
              (a, b) => new Date(b.overtimeDate) - new Date(a.overtimeDate)
            )
          );
        }
      }
    });
  };

  // Function to valiadate date range
  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const calculateSummary = (data, ActionType) => {
    let totalWorkMinutes = 0;
    let totalInitialOT = 0;
    let totalLate = 0;
    let totalBreak = 0;
    let totalFinalOT = 0;
    let amendedMinutes = 0;

    if (!data || data.length === 0) {
      return {
        totalWork: "00:00",
        initialOT: "00:00",
        late: "00:00",
        breakTime: "00:00",
        finalOT: "00:00",
        amendedOT: "00:00",
      };
    }

    data.forEach((record) => {
      /* -------- TOTAL WORK -------- */
      const work =
        ActionType === "1"
          ? getToltalWorkHours(record)
          : record?.totalworkduration || "00:00";

      totalWorkMinutes += parseHourMinutesStringToMinutes(work || "00:00");

      /* -------- INITIAL OT -------- */
      const initial =
        ActionType === "1"
          ? getOvertimeDuration(record)
          : record?.initialovertime || "00:00";

      totalInitialOT += parseHourMinutesStringToMinutes(initial || "00:00");

      /* -------- LATE -------- */
      let lateMinutes = 0;

      if (ActionType === "1") {
        if (record?.punchinstatus === "late") {
          lateMinutes = differenceBetweenTwoTime(
            record.shiftstarttime,
            record.checkintime
          );
        }
      } else {
        lateMinutes = parseHourMinutesStringToMinutes(
          record?.latecheckinduration || "00:00"
        );
      }

      totalLate += lateMinutes;

      /* -------- BREAK -------- */
      const breakMinutes = parseHourMinutesStringToMinutes(
        record?.breakduration || "00:00"
      );
      totalBreak += breakMinutes;

      /* -------- FINAL OT -------- */
      if (ActionType === "1") {
        const otStr = getOvertimeDuration(record);
        const otMin = parseHourMinutesStringToMinutes(otStr || "00:00");

        // ⚠️ allow negative value
        const finalMin = otMin - lateMinutes - breakMinutes;
        totalFinalOT += finalMin;
      } else {
        const updatedOT =
          record?.overtimeUpdate && record.overtimeUpdate !== "undefined:00"
            ? record.overtimeUpdate
            : record?.finalovertime || "00:00";

        totalFinalOT += parseHourMinutesStringToMinutes(updatedOT);
      }

      /* -------- AMENDED OT -------- */
      if (ActionType === "2") {
        amendedMinutes += parseHourMinutesStringToMinutes(
          record?.overtimeUpdate || "00:00"
        );
      }
    });

    // 🔥 function to support negative HH:mm
    const formatMinutes = (mins) => {
      const sign = mins < 0 ? "-" : "";
      const abs = Math.abs(mins);
      return sign + generateHourMinutesFromMinutes(abs);
    };

    return {
      totalWork: formatMinutes(totalWorkMinutes),
      initialOT: formatMinutes(totalInitialOT),
      late: formatMinutes(totalLate),
      breakTime: formatMinutes(totalBreak),
      finalOT: formatMinutes(totalFinalOT),
      amendedOT: formatMinutes(amendedMinutes),
    };
  };

  // Function to Prepare CSV
  const prepareCSV = async (event, done) => {
    if (ActionType === "1") {
      const exportData = uiTableData.length ? uiTableData : overtimefilterdata;
      if (exportData?.length > 0) {
        setCSVOvertimeList(
          reduce(
            exportData,
            function (result, record, index) {
              console.log("index-->", index);
              const filteruser = userList?.filter(
                (item) => item?.userid === record?.userid
              );
              const {
                date_th: day,
                shortMonthName,
                year,
                longDay,
              } = dateInDetail(record.checkindate);
              const {
                date_th: startDate_th1,
                shortMonthName: startMonthName1,
                year: end_year1,
              } = dateInDetail(record.checkoutdate);
              const diff = differenceBetweenTwoTime(
                record.shiftstarttime,
                record.checkintime
              );
              const overTimeStr = getOvertimeDuration(record);
              const overtimeMinutes =
                parseHourMinutesStringToMinutes(overTimeStr);

              const lateMinutes = record?.punchinstatus === "late" ? diff : 0;
              const breakMinutes = record?.breakduration
                ? record?.breakduration
                : 0;
              const finalMinutes =
                overtimeMinutes -
                lateMinutes -
                parseHourMinutesStringToMinutes(breakMinutes);

              const summary = calculateSummary(exportData, "1");

              const row = {
                "Employee ID": filteruser[0]?.employeeid,
                "Employee Name": record?.fullname,
                Department: record?.departmentname,
                "Checkin Date": `${day} ${shortMonthName} ${year}`,
                "Checkin Day": `${moment(record.checkindate).format("dddd")}`,
                "Checkin Time": record?.checkintime,
                "Checkout Date": `${day} ${shortMonthName} ${year}`,
                "Checkout Day": `${moment(record.checkoutdate).format("dddd")}`,
                "Checkout Type": record?.checkouttype,
                "Checkout Time": record?.checkouttime,
                "Total Work Duration": getToltalWorkHours(record),
                "Initial Overtime": getOvertimeDuration(record),
                "Late Check-in Duration":
                  record?.punchinstatus === "late"
                    ? generateHourMinutesFromMinutes(diff)
                    : "00:00",
                "Break Time": record?.breakduration
                  ? record?.breakduration
                  : "-",
                "Break Type": record?.break_status
                  ? record?.break_status === "auto"
                    ? "Auto"
                    : "Manual"
                  : "-",
                "Final Overtime": generateHourMinutesFromMinutes(finalMinutes),
              };

              if (activeSortColumn.length > 0) {
                const filteredRow = {};
                columns.forEach((col) => {
                  if (activeSortColumn.includes(col.dataIndex)) {
                    filteredRow[col.title] = row[col.title];
                  }
                });
                result.push(filteredRow);
              } else {
                result.push(row);
              }

              if (index + 1 === exportData?.length) {
                const row = {
                  "Employee ID": "",
                  "Employee Name": "SUB TOTAL",
                  Department: "",
                  "Checkin Date": "",
                  "Checkin Day": "",
                  "Checkin Time": "",
                  "Checkout Date": "",
                  "Checkout Day": "",
                  "Checkout Type": "",
                  "Checkout Time": "",
                  "Total Work Duration": summary.totalWork,
                  "Initial Overtime": summary.initialOT,
                  "Late Check-in Duration": summary.late,
                  "Break Time": summary.breakTime,
                  "Break Type": "",
                  "Final Overtime": summary.finalOT,
                };

                if (activeSortColumn.length > 0) {
                  const filteredRow = {};
                  columns.forEach((col) => {
                    if (activeSortColumn.includes(col.dataIndex)) {
                      filteredRow[col.title] = row[col.title];
                    }
                  });
                  result.push(filteredRow);
                } else {
                  result.push(row);
                }
              }
              return result;
            },
            []
          )
        );
        setTimeout(() => {
          csvLinkEl.current.link.click();
        });
      } else {
        message.error(`No data available to download.`);
      }
    } else {
      const exportData = uiTableData.length ? uiTableData : overtimefilterdata1;
      if (exportData?.length > 0) {
        setCSVOvertimeList(
          reduce(
            exportData,
            function (result, record, index) {
              const {
                date_th: day,
                shortMonthName,
                year,
                longDay,
              } = dateInDetail(record.overtimeDate);
              const {
                date_th: startDate_th1,
                shortMonthName: startMonthName1,
                year: end_year1,
              } = dateInDetail(record.checkoutdate);
              const diff = differenceBetweenTwoTime(
                record?.shiftendtime,
                record?.endTime
              );
              const summary = calculateSummary(overtimefilterdata1, "2");
              const row = {
                "Employee ID": record?.employeeId,
                "Employee Name": record?.fullName,
                Department: record?.departmentname,
                "Checkin Date": `${day} ${shortMonthName} ${year}`,
                "Checkin Day": `${moment(record.overtimeDate).format("dddd")}`,
                "Checkin Time": record?.startTime,
                "Checkout Date": `${day} ${shortMonthName} ${year}`,
                "Checkout Day": `${moment(record.overtimeDate).format("dddd")}`,
                "Checkout Time": record?.endTime,
                // "Duration (Hours)": record?.overtimeDuration,
                Action: record?.statusId === 1 ? "Yes" : "No",
                "Overtime Amended": record?.overtimeUpdate,
                Comments: record?.commands,
                "Checkout Type": record?.checkouttype,
                "Total Work Duration": record?.totalworkduration,
                "Initial Overtime": record?.initialovertime,
                "Late Check-in Duration": record?.latecheckinduration,
                "Break Time": record?.breakduration,
                "Break Type":
                  record?.break_status === "auto" ? "Auto" : "Manual",
                "Final Overtime": record?.finalovertime,
              };

              if (activeSortColumn.length > 0) {
                const filteredRow = {};
                columns.forEach((col) => {
                  if (activeSortColumn.includes(col.dataIndex)) {
                    filteredRow[col.title] = row[col.title];
                  }
                });
                result.push(filteredRow);
              } else {
                result.push(row);
              }

              if (index + 1 === exportData?.length) {
                const row = {
                  "Employee ID": "",
                  "Employee Name": "SUB TOTAL",
                  Department: "",
                  "Checkin Date": "",
                  "Checkin Day": "",
                  "Checkin Time": "",
                  "Checkout Date": "",
                  "Checkout Day": "",
                  "Checkout Time": "",
                  Action: "",
                  "Overtime Amended": summary.amendedOT,
                  Comments: "",
                  "Checkout Type": "",
                  "Total Work Duration": summary.totalWork,
                  "Initial Overtime": summary.initialOT,
                  "Late Check-in Duration": summary.late,
                  "Break Time": summary.breakTime,
                  "Break Type": "",
                  "Final Overtime": summary.finalOT,
                };

                if (activeSortColumn.length > 0) {
                  const filteredRow = {};
                  columns.forEach((col) => {
                    if (activeSortColumn.includes(col.dataIndex)) {
                      filteredRow[col.title] = row[col.title];
                    }
                  });
                  result.push(filteredRow);
                } else {
                  result.push(row);
                }
              }
              return result;
            },
            []
          )
        );
        setTimeout(() => {
          csvLinkEl.current.link.click();
        });
      } else {
        message.error(`No data available to download.`);
      }
    }
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 100,
    showSizeChanger: false,
  };
  const { hours, notes } = values;

  const [scrollY, setScrollY] = useState();
  useEffect(() => {
    const updatePageTitleHeight = () => {
      const h = pageTitleRef?.current?.offsetHeight || 0;
      setPageTitleHeight(h);
    };

    // Initial measurement
    updatePageTitleHeight();

    // Use ResizeObserver for accurate content/size changes
    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(updatePageTitleHeight);
      if (pageTitleRef.current) ro.observe(pageTitleRef.current);
    }

    window.addEventListener("resize", updatePageTitleHeight);
    return () => {
      window.removeEventListener("resize", updatePageTitleHeight);
      if (ro && pageTitleRef.current) ro.unobserve(pageTitleRef.current);
    };
  }, [pageTitleRef]);

  useEffect(() => {
    const calculateScrollY = () => {
      // Keep a safe minimum so the table remains usable
      const baseOffset = showSelection ? 310 : 375;
      const dynamicHeight = Math.max(
        120,
        window.innerHeight - pageTitleHeight - baseOffset
      );
      setScrollY(dynamicHeight);
    };
    calculateScrollY();
    window.addEventListener("resize", calculateScrollY);
    return () => window.removeEventListener("resize", calculateScrollY);
  }, [pageTitleHeight, selectedRows]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(selectedRows);
    },
    columnWidth: 100,
  };
  const footerStyle = {
    position: "sticky",
    bottom: -25,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "20px -24px -20px -20px",
    zIndex: 10,
  };
  return (
    <Overtimewrap>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={12} className="align-left">
          <h6 className="pt-2">Overtime</h6>
        </Col>
        <Col xs={24} sm={4} md={12} className="align-right">
          <div className="d-flex align-items-center gap-2 justify-content-end">
            <Dropdown
              overlay={sortMenu}
              trigger={["click"]}
              placement="bottomRight"
              getPopupContainer={() => containerRef.current}
            >
              <Button
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  border: 0,
                }}
              >
                <SortAscendingOutlined />
              </Button>
            </Dropdown>
            <StyledButtonoutlined
              onClick={prepareCSV}
              disabled={
                ActionType === "1"
                  ? overtimefilterdata.length === 0
                  : overtimefilterdata1.length === 0
              }
            >
              Export CSV file
            </StyledButtonoutlined>
            <CSVLink
              header={CSVHeaders}
              data={CSVOvertimeList}
              filename={"overtime-report.csv"}
              asyncOnClick={true}
              ref={csvLinkEl}
            />
          </div>
        </Col>
      </Row>
      <Row className="page-title" ref={pageTitleRef}>
        <Col
          xs={24}
          sm={24}
          md={20}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledApprovalSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                staff_name: "",
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(addMonthinDate(getKenyanDateTime(), -1)),
                end_date: momentDate(addDaysinDate(getKenyanDateTime())),
                department: "",
                break_status: "",
              }}
              onFinish={getOvertimeReport}
            >
              <Form.Item
                name="duration_type"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Select
                  placeholder="Select..."
                  options={REPORT_DURATION_TYPES}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
              <Select
                style={{ marginRight: "20px" }}
                className="selectbox"
                placeholder="Employee type"
                defaultValue={"1"}
                options={[
                  {
                    value: "1",
                    label: "Waiting For Action",
                  },
                  {
                    value: "2",
                    label: "Action history",
                  },
                ]}
                onChange={(e) => setActionType(e)}
                getPopupContainer={() => containerRef.current}
              />

              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="Start date"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="End date"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <Form.Item
                      name="month"
                      rules={[
                        {
                          required: true,
                          message: "",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select..."
                        options={monthList}
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
              <Form.Item
                name="staff_name"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="name"
                  placeholder="Select Employee"
                  options={concat(
                    {
                      userid: "",
                      name: "All Employee",
                    },
                    STAFF_LIST
                  )}
                  fieldNames={{
                    label: "name",
                    value: "userid",
                  }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
              <Form.Item name="department">
                <Select
                  placeholder="Select Department"
                  options={concat(
                    {
                      department_id: "",
                      department_name: "All Departments",
                    },
                    uniqBy(allDepartmentList, "department_id")
                  )}
                  fieldNames={{
                    label: "department_name",
                    value: "department_id",
                  }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
              <Form.Item name="break_status">
                <Select
                  showSearch
                  // placeholder="Search break type"
                  name="break_status"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    option.label
                      .toLowerCase()
                      .includes(input.toLocaleLowerCase())
                  }
                  options={concat(
                    {
                      label: "All Break Type",
                      value: "",
                    },
                    [
                      { label: "Auto", value: "Auto" },
                      { label: "Manual", value: "Manual" },
                    ]
                  )}
                  fieldNames={{
                    label: "label",
                    value: "value",
                  }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </StyledApprovalSearchForm>
          </Space>
        </Col>
        {ActionType === "1" && (
          <Col xs={24} sm={4} md={4} className="align-right">
            <Button
              type="link"
              className="change-view"
              onClick={() => setShowSelection(true)}
              disabled={showSelection || overtimefilterdata.length === 0}
            >
              Multi Select
            </Button>
          </Col>
        )}
      </Row>

      <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={
            ActionType === "1" ? overtimefilterdata : overtimefilterdata1
            // ActionType === "1" ? dummydata : dummydata
          }
          columns={finalColumns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="userpunchactionid"
          scroll={{ y: scrollY }}
          onChange={handleTableChange}
          rowSelection={showSelection ? rowSelection : null}
          style={{ minHeight: scrollY + 55 }}
          // pagination={
          //   (ActionType === "1" ? dummydata : dummydata).length > 20
          //     ? paginationOptions
          //     : false
          // }
          pagination={
            (ActionType === "1" ? overtimefilterdata : overtimefilterdata1)
              .length > 100
              ? paginationOptions
              : false
          }
          // summary={(pageData) => (
          //   <Table.Summary fixed="bottom">
          //     {(() => {
          //       let totalWorkMinutes = 0;
          //       let initialOvertimeMinutes = 0;
          //       let lateCheckinMinutes = 0;
          //       let breakTimeMinutes = 0;
          //       let finalOvertimeMinutes = 0;
          //       let amendedMinutes = 0;

          //       pageData.forEach((record) => {
          //         /* ---------------------------- TOTAL WORK TIME ---------------------------- */
          //         if (ActionType === "1") {
          //           const duration = getToltalWorkHours(record); // "HH:mm"
          //           totalWorkMinutes +=
          //             parseHourMinutesStringToMinutes(duration);
          //         } else {
          //           totalWorkMinutes += parseHourMinutesStringToMinutes(
          //             record?.totalworkduration
          //           );
          //         }

          //         /* ---------------------------- INITIAL OVERTIME --------------------------- */
          //         const initialOt =
          //           ActionType === "1"
          //             ? getOvertimeDuration(record)
          //             : record?.initialovertime;

          //         initialOvertimeMinutes +=
          //           parseHourMinutesStringToMinutes(initialOt);

          //         /* ---------------------------- LATE CHECK-IN ------------------------------ */
          //         const late =
          //           record?.punchinstatus === "late"
          //             ? differenceBetweenTwoTime(
          //                 record.shiftstarttime,
          //                 record.checkintime
          //               )
          //             : 0;

          //         lateCheckinMinutes +=
          //           ActionType === "1"
          //             ? late
          //             : parseHourMinutesStringToMinutes(
          //                 record?.latecheckinduration
          //               );

          //         /* ---------------------------- BREAK TIME -------------------------------- */
          //         if (record?.breakduration) {
          //           breakTimeMinutes += parseHourMinutesStringToMinutes(
          //             record?.breakduration
          //           );
          //         }

          //         /* ---------------------------- FINAL OVERTIME ----------------------------- */
          //         /* ---------------------------- FINAL OVERTIME ----------------------------- */
          //         if (ActionType === "1") {
          //           const overTimeStr = getOvertimeDuration(record);
          //           const overtimeMinutes =
          //             parseHourMinutesStringToMinutes(overTimeStr);

          //           // late per row
          //           const lateMinutes =
          //             record?.punchinstatus === "late"
          //               ? differenceBetweenTwoTime(
          //                   record.shiftstarttime,
          //                   record.checkintime
          //                 )
          //               : 0;

          //           // break per row
          //           const breakMinutes = record?.breakduration
          //             ? parseHourMinutesStringToMinutes(record.breakduration)
          //             : 0;

          //           const finalMinutes =
          //             overtimeMinutes - lateMinutes - breakMinutes;

          //           finalOvertimeMinutes += Math.max(finalMinutes, 0);
          //         } else {
          //           const updatedOT =
          //             record?.overtimeUpdate &&
          //             record.overtimeUpdate !== "undefined:00"
          //               ? record.overtimeUpdate
          //               : record?.finalovertime;

          //           finalOvertimeMinutes +=
          //             parseHourMinutesStringToMinutes(updatedOT);
          //         }

          //         /* ---------------------------- AMENDED OVERTIME (ActionType 2) ------------ */
          //         if (ActionType === "2") {
          //           amendedMinutes += parseHourMinutesStringToMinutes(
          //             record?.overtimeUpdate
          //           );
          //         }
          //       });

          //       return (
          //         <Table.Summary.Row
          //           style={{
          //             background: "#f0f2f5",
          //             position: "sticky",
          //             bottom: 0,
          //             zIndex: 1000,
          //           }}
          //         >
          //           <Table.Summary.Cell index={0} colSpan={10}>
          //             <b>Sub Total</b>
          //           </Table.Summary.Cell>

          //           <Table.Summary.Cell index={1}>
          //             {generateHourMinutesFromMinutes(totalWorkMinutes)}
          //           </Table.Summary.Cell>

          //           <Table.Summary.Cell index={2}>
          //             {generateHourMinutesFromMinutes(initialOvertimeMinutes)}
          //           </Table.Summary.Cell>

          //           <Table.Summary.Cell index={3}>
          //             {generateHourMinutesFromMinutes(lateCheckinMinutes)}
          //           </Table.Summary.Cell>

          //           <Table.Summary.Cell index={4}>
          //             {generateHourMinutesFromMinutes(breakTimeMinutes)}
          //           </Table.Summary.Cell>
          //           <Table.Summary.Cell index={5}></Table.Summary.Cell>

          //           <Table.Summary.Cell index={6}>
          //             {generateHourMinutesFromMinutes(finalOvertimeMinutes)}
          //           </Table.Summary.Cell>
          //           <Table.Summary.Cell index={7}></Table.Summary.Cell>

          //           {ActionType === "2" && (
          //             <Table.Summary.Cell index={8} colSpan={2}>
          //               {generateHourMinutesFromMinutes(amendedMinutes)}
          //             </Table.Summary.Cell>
          //           )}
          //         </Table.Summary.Row>
          //       );
          //     })()}
          //   </Table.Summary>
          // )}
          summary={(pageData) => {
            const summary = calculateSummary(pageData, ActionType);

            return (
              <Table.Summary fixed="bottom">
                <Table.Summary.Row
                  style={{
                    background: "#f0f2f5",
                    position: "sticky",
                    bottom: 0,
                    zIndex: 1000,
                    fontWeight: 600,
                  }}
                >
                  {finalColumns.map((col, index) => {
                    if (index === 0) {
                      return (
                        <Table.Summary.Cell key={index}>
                          <b>Sub Total</b>
                        </Table.Summary.Cell>
                      );
                    }

                    const map = {
                      totalworkduration: summary.totalWork,
                      initialovertime: summary.initialOT,
                      latecheckinduration: summary.late,
                      breakduration: summary.breakTime,
                      finalovertime: summary.finalOT,
                      overtimeUpdate: summary.amendedOT,
                    };

                    return (
                      <Table.Summary.Cell
                        key={showSelection ? index + 1 : index}
                      >
                        {map[col.dataIndex] || ""}
                      </Table.Summary.Cell>
                    );
                  })}
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      </Spin>
      {showSelection && (
        <div style={footerStyle}>
          <ButtonOutlined
            className="border-0"
            onClick={() => {
              updateform.resetFields();
              setIsbulkApproveModalOpen(false);
              setIsbulkDeclineModalOpen(false);
              setShowSelection(false);
              setSelectedRowKeys([]);
              setSelectedRows([]);
            }}
          >
            Cancel
          </ButtonOutlined>
          <ButtonOutlined
            onClick={() => setIsbulkDeclineModalOpen(true)}
            disabled={selectedRows?.length === 0}
          >
            Decline
          </ButtonOutlined>
          <ButtonFilled
            type="primary"
            htmlType="submit"
            onClick={() => setIsbulkApproveModalOpen(true)}
            disabled={selectedRows?.length === 0}
          >
            Approve
          </ButtonFilled>
        </div>
      )}
      <Modal
        title="Add Note"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={false}
        keyboard={false}
      >
        <div>
          <Form1.Group>
            {clickactionId === 1 && (
              <>
                <Form1.Label
                  style={{ Font: "normal normal normal 16px/19px Lato" }}
                >
                  Duration:
                </Form1.Label>{" "}
                <br></br>
                <Input
                  style={{
                    width: "100%",
                    border: "1px solid #9B9B9B",
                    marginBottom: "10px",
                  }}
                  placeholder=""
                  type="text"
                  name="hours"
                  value={hours}
                  onChange={handleChange}
                />
                {errors.hours && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "10px",
                      marginBottom: "-5px",
                    }}
                  >
                    {errors.hours}
                  </p>
                )}
                <br></br>
              </>
            )}
            <Form1.Label
              style={{ Font: "normal normal normal 16px/19px Lato" }}
            >
              Note:
            </Form1.Label>{" "}
            <br></br>
            <TextArea
              style={{ width: "100%", border: "1px solid #9B9B9B" }}
              placeholder=""
              type="text"
              name="notes"
              value={notes}
              rows={4}
              maxLength={500}
              onChange={handleChange}
            />
            {errors.notes && (
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "-5px" }}
              >
                {errors.notes}
              </p>
            )}
          </Form1.Group>

          <Col
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "right",
            }}
          >
            <ButtonFilled onClick={handleFormsubmit}>Save</ButtonFilled>
          </Col>
        </div>
      </Modal>
      <Modal
        title={isbulkApproveModalOpen ? "Approve Overtime" : "Decline Overtime"}
        open={isbulkApproveModalOpen || isbulkDeclineModalOpen}
        onCancel={() => {
          updateform.resetFields();
          setIsbulkApproveModalOpen(false);
          setIsbulkDeclineModalOpen(false);
          setShowSelection(false);
          setSelectedRowKeys([]);
          setSelectedRows([]);
        }}
        footer={null}
        width={isbulkApproveModalOpen ? 900 : 600}
        destroyOnClose
      >
        <Row gutter={24}>
          {/* LEFT SIDE - EMPLOYEE LIST */}
          {isbulkApproveModalOpen && (
            <Col xs={24} md={11}>
              <div>
                {/* Header Row */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 1.5fr 1.5fr 40px",
                    padding: "8px 12px",
                    fontWeight: 600,
                    fontSize: 13,
                    color: "#666",
                    borderTopLeftRadius: 6,
                    borderTopRightRadius: 6,
                    borderBottom: "1px solid #e8e8e8",
                    marginBottom: 2,
                    background: "#e8e8e8",
                  }}
                >
                  <div>Name</div>
                  <div>Employee ID</div>
                  <div>Duration</div>
                  {/* <div></div> */}
                </div>

                {/* Employee Rows */}
                <div style={{ maxHeight: 220, overflowY: "auto" }}>
                  {selectedRows.map((item, index) => {
                    // 🔹 keep same functionality — just moved outside JSX
                    const overTimeStr = getOvertimeDuration(item);
                    const overtimeMinutes =
                      parseHourMinutesStringToMinutes(overTimeStr);

                    const diff = differenceBetweenTwoTime(
                      item.shiftstarttime,
                      item.checkintime
                    );

                    const lateMinutes =
                      item?.punchinstatus === "late" ? diff : 0;

                    const breakMinutes = item?.breakduration
                      ? item?.breakduration
                      : 0;

                    const finalMinutes =
                      overtimeMinutes -
                      lateMinutes -
                      parseHourMinutesStringToMinutes(breakMinutes);

                    return (
                      <div key={index} style={{ background: "#edf0ff" }}>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "2fr 1.5fr 1.5fr 40px",
                            alignItems: "center",
                            background: "#edf0ff",
                            padding: "12px",
                            fontSize: 14,
                            maxHeight: 320,
                            overflowY: "auto",
                          }}
                        >
                          <div style={{ color: "#1a1a1a", fontWeight: 500 }}>
                            {item.fullname}
                          </div>

                          <div style={{ color: "#666" }}>
                            {userList?.find(
                              (val) => val?.userid === item.userid
                            )?.employeeid || "EM12345"}
                          </div>

                          <div style={{ color: "#666" }}>
                            <TimePicker
                              format="HH:mm"
                              size="small"
                              style={{ width: 100 }}
                              showNow={false}
                              addon={() => null}
                              value={
                                item?.changedovertime
                                  ? dayjs(item.changedovertime, "HH:mm")
                                  : getOvertimeDuration(item)
                                  ? dayjs(
                                      generateHourMinutesFromMinutes(
                                        finalMinutes
                                      ),
                                      "HH:mm"
                                    )
                                  : null
                              }
                              onSelect={(time) => {
                                setSelectedRows((prev) =>
                                  prev.map((row) =>
                                    row.userpunchactionid ===
                                    item.userpunchactionid
                                      ? {
                                          ...row,
                                          changedovertime: time
                                            ? time.format("HH:mm")
                                            : "",
                                        }
                                      : row
                                  )
                                );
                              }}
                              getPopupContainer={() => containerRef.current}
                            />
                          </div>

                          <div style={{ textAlign: "center" }}></div>
                        </div>

                        <hr
                          style={{
                            margin: "0px 10px",
                            background: "#ffffff",
                            height: 2,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
          )}

          {/* RIGHT SIDE - FORM */}
          <Col xs={24} md={isbulkApproveModalOpen ? 13 : 24}>
            <Form form={updateform} layout="vertical" onFinish={update}>
              <Form.Item
                label={isbulkApproveModalOpen ? "Notes" : "Decline reason"}
                name="notes"
                rules={[
                  { required: true, message: "This field is required" },
                  { max: 250, message: "Maximum 250 characters allowed" },
                ]}
              >
                <Input.TextArea
                  placeholder="Enter notes"
                  rows={4}
                  maxLength={250}
                  showCount={{
                    formatter: ({ count }) => `Maximum 250 characters`,
                  }}
                  // onChange={(e) => setNote(e.target.value)}
                />
              </Form.Item>

              <div style={{ textAlign: "right", marginTop: "100px" }}>
                <Button
                  onClick={() => {
                    // reset notes field in modal form and close modal
                    updateform.resetFields();
                    setIsbulkApproveModalOpen(false);
                    setIsbulkDeclineModalOpen(false);
                    setShowSelection(false);
                    setSelectedRowKeys([]);
                    setSelectedRows([]);
                  }}
                  style={{ marginRight: 8 }}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  loading={loading}
                  htmlType="submit"
                  // disabled={!form.getFieldValue("overtimeRate")}
                >
                  {isbulkApproveModalOpen ? "Approve" : "Decline"}
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Modal>
    </Overtimewrap>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userList: getUserList(state),
  menuList: getMenuList(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(OvertimeReport);
